<template>
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center space-x-2">
      <span class="text-lg font-medium">
        <span class="text-primary-600 font-bold">{{ rating }}</span>
        <span class="font-bold"> out of 5</span>
      </span>
      <RatingStars
        class="text-primary"
        :rating="rating"
        size="md"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  rating: number
  totalReviews?: number
  reviewsText?: string
}>()
</script>
